import script from "./AudioTrimmer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioTrimmer.vue?vue&type=script&setup=true&lang=ts"

import "./AudioTrimmer.vue?vue&type=style&index=0&id=26b85ade&lang=scss"

const __exports__ = script;

export default __exports__